import * as React from 'react';

interface ILocalizerProps {
    translate?: (textToLocalize: string) => string;
    children: React.ReactNode;
}

export const LocalizationContext = React.createContext({ translate: defaultTranslate });

function defaultTranslate(text: string) {
    return text;
}

export function LocalizationProvider(props: ILocalizerProps) {
    const { translate = defaultTranslate } = props;
    return (
        <LocalizationContext.Provider value={{ translate }}>
            {props.children}
        </LocalizationContext.Provider>
    );
}

export function useTranslate() {
    const localizationProvider = React.useContext(LocalizationContext);
    return localizationProvider.translate;
}
